module.exports = __webpack_public_path__ + "static/media/SPRAY0.0bc57efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY0.png
// module id = 282
// module chunks = 0